// Centralized, production-safe logger.
// Console output is gated to dev mode OR an explicit runtime debug flag, so
// production stays quiet without losing diagnostics. Nothing is deleted —
// to re-enable logs in production, set window.__FF_DEBUG__ = true or
// localStorage.setItem("ff_debug", "1") in the browser console.
const isDev = process.env.NODE_ENV !== "production";

function debugEnabled() {
  if (isDev) return true;
  try {
    if (typeof window === "undefined") return false;
    if (window.__FF_DEBUG__ === true) return true;
    return !!window.localStorage && window.localStorage.getItem("ff_debug") === "1";
  } catch {
    return false;
  }
}

export const logger = {
  log: (...args) => { if (debugEnabled()) console.log(...args); },
  info: (...args) => { if (debugEnabled()) console.info(...args); },
  debug: (...args) => { if (debugEnabled()) console.debug(...args); },
  warn: (...args) => { if (debugEnabled()) console.warn(...args); },
  error: (...args) => { if (debugEnabled()) console.error(...args); },
};

export default logger;
